import React, {useEffect, useState} from 'react';
import styleTable from './table.module.css'
import TextArea from "./textArea";
import {ru} from "../../../data/ru";
import {by} from "../../../data/by";

const Table = ({defaultValue, id, change,}) => {
    let language = localStorage.getItem('lang') === 'ru' ? ru.RoleIdThree : by.RoleIdThree;

    const [rows, setRows] = useState(defaultValue?.length||2);
    const [columns, setColumns] = useState(defaultValue?.[0]?.length||2);
    const [answers, setAnswers] = useState(defaultValue||[]);

    useEffect(() => {
        setAnswers(prevAnswers => {
            const updatedAnswers = [...prevAnswers];

            // Добавление новых строк, если необходимо
            while (updatedAnswers.length < rows) {
                updatedAnswers.push([{ text: '', percent: '' }, ...Array(columns - 1).fill('')]);
            }

            // Добавление новых столбцов, если необходимо
            updatedAnswers.forEach(row => {
                while (row.length < columns) {
                    row.push("");
                }
            });

            return updatedAnswers;
        });
    }, [rows, columns]);


    const handleAddRow = () => {
        setRows(rows + 1);
    };

    const handleAddColumn = () => {
        setColumns(columns + 1);
    };
    const handleDelete =(column,row)=>{
        const updatedAnswers = [...answers];
        if(column===0){
            setColumns(columns-1)
            const arr =[]
            updatedAnswers.forEach((item)=>{
                arr.push(item.filter((_,j)=>j!==row))
            })
            console.log(arr)
            setAnswers(arr)
        }
        if(row===0){
            setRows(rows-1)
            const arr = updatedAnswers.filter((item,i)=>i!==column)
            setAnswers(arr)
        }
    }
    const handlerInput = (e, row, column) => {
        const updatedAnswers = [...answers];
        if (row === 0 || column === 0) {
            updatedAnswers[row][column] = { ...updatedAnswers[row][column], text: e.target.value };
        } else {
            if (updatedAnswers[row].includes(true)) {
                updatedAnswers[row] = updatedAnswers[row].map(item => (typeof item === "boolean" ? "" : item));
            }
            updatedAnswers[row][column] = !updatedAnswers[row][column];
        }
        setAnswers(updatedAnswers);
    };

    const handlerPercent = (e,row)=>{
        const updatedAnswers = [...answers];
        updatedAnswers[row][0].percent = e.target.value;
        setAnswers(updatedAnswers)
    }
    useEffect(()=>{
        change(answers)
    },[answers])

    const renderTable = () => {
        const table = [];
        for (let i = 0; i < rows; i++) {
            const row = [];
            for (let j = 0; j < columns; j++) {
                if (i === 0 && j === 0) {
                    row.push(
                        <td key={j} className={styleTable.headerTable}>
                            Утверждение/Высказывание
                        </td>);
                } else if (i === 0 || j === 0) {
                    row.push(
                        <td key={j} className={styleTable.headerTable}>
                            <div className={styleTable.inputButtonContainer}>
                                <TextArea className={styleTable.tableTextarea} type={'text'} value={answers?.[i]?.[j]?.text||''} changeHandler={e => handlerInput(e, i, j)}/>
                                <button title={"Удалить"} className={styleTable.tableDeleteButton} onClick={() => handleDelete(i, j)}>x</button>
                            </div>
                            {j===0 &&
                            <div style={{display: 'flex'}}>
                                <h4>%</h4>
                                <input className={styleTable.tableInputNumber} type="number" min={0} max={100} value={answers?.[i]?.[j]?.percent||0} onChange={e=>handlerPercent(e,i)}/>
                            </div>}

                        </td>);
                } else {
                    row.push(<td key={j}><input className={styleTable.tableRadio} type={'radio'} onChange={e => handlerInput(e, i, j)}
                                                checked={answers?.[i]?.[j] === true}/></td>);
                }
            }
            table.push(<tr className={styleTable.rowContainer} key={i}>{row}</tr>);
        }
        return table;
    };

    return (
        <div>
            <table className={styleTable.tableContainer}>
                <tbody>
                {renderTable()}
                </tbody>
            </table>
            <button className={styleTable.tableAddButton} onClick={handleAddRow}>{language.addLine}</button>
            <button className={styleTable.tableAddButton} onClick={handleAddColumn}>{language.addColumn}</button>
        </div>
    );
};

export default Table;
